import { Stack, Typography } from '@mui/material';
import React from 'react';

const NoWidgetsView: React.FC = () => (
	<Stack
		data-testid="no-auth-view"
		direction="column"
		alignItems="center"
		height="100%"
		gap={2}
		mt={10}
	>
		<Typography variant="h4">{intl.tr('noWidgetsView.title')}</Typography>
		<Typography variant="body1">{intl.tr('noWidgetsView.message')}</Typography>
	</Stack>
);

export default NoWidgetsView;
